module.exports = __webpack_public_path__ + "static/images/hero.69431be7ac0f7bbd264f670c23fc20ed.jpg";